import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import ChevronLeft from '@atlaskit/icon/core/chevron-left';
import CrossIcon from '@atlaskit/icon/core/cross';
import Image from '@atlaskit/image';
import AkModalDialog, { ModalBody, ModalHeader } from '@atlaskit/modal-dialog';
import { Flex, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { type ConversationAssistantConfig } from '@atlassian/conversation-assistant';

import SmartCreateIcon from '../assets/smart-create.svg';

import { StagingArea } from './staging-area';

type SmartCreationModalProps = {
	spaceKey: string;
	config: ConversationAssistantConfig;
	headerIcon: React.ReactNode;
	handleClose: () => void;
	handlePrevious: () => void;
	title: string;
	contentId: string;
};

const styles = cssMap({
	titleGroup: {
		alignItems: 'center',
	},
	modalTitleIcon: {
		marginLeft: token('space.100'),
		marginRight: token('space.100'),
	},
	modalTitle: {
		font: token('font.body.large'),
	},
});

export const SmartCreationModal = ({
	config,
	handleClose,
	handlePrevious,
	headerIcon,
	title,
	spaceKey,
	contentId,
}: SmartCreationModalProps) => {
	return (
		<AkModalDialog width="100%">
			<ModalHeader>
				<Flex xcss={styles.titleGroup}>
					<IconButton icon={ChevronLeft} label="Go back" shape="circle" onClick={handlePrevious} />
					<Inline xcss={styles.modalTitleIcon}>
						<Image src={SmartCreateIcon} alt="" />
					</Inline>
					{headerIcon}
					<Inline xcss={styles.modalTitle}>{title}</Inline>
				</Flex>
				<IconButton icon={CrossIcon} label="Close" shape="circle" onClick={handleClose} />
			</ModalHeader>
			<ModalBody>
				<StagingArea config={config} spaceKey={spaceKey} contentId={contentId} />
			</ModalBody>
		</AkModalDialog>
	);
};
